import { useContext } from 'react';
import { ProjectContext } from '../../../context/ProjectContext';
const Pagination = () => {
    const { totalPages , isLoading , currentPage , gotoPage , nextPage , prevPage} = useContext(ProjectContext);
    if(totalPages <= 1 || isLoading){ //if only 1 page no point showing prev and next
        return null;
    }
    const pageNumber = [];
    for(let i = 1;i <= totalPages;i++){
        pageNumber.push(i);
    }
    // console.log(totalPages);
    return (
        <>
            <div className="mt-8 flex justify-center space-x-4 w-full">
                <button onClick={prevPage} disabled={currentPage == 1} className={`px-3 py-1 rounded-md bg-black text-white disabled:cursor-not-allowed disabled:text-black disabled:bg-gray-200`}>
                    Prev
                </button>
                {pageNumber.map((page) => {
                const isActive = page == currentPage;
                return (
                    <button
                    key={page} // Add a key for React
                    onClick={() => gotoPage(page)}
                    className={`px-2.5 py-0.5 rounded-md ${ // <-- Added space and removed space-x-4
                        isActive ? "bg-black text-white border-[#161617]" : "bg-gray-200 text-gray-700 border-gray-400 hover:bg-gray-300"
                    }`}
                    >
                    {page}
                    </button>
                );
                })}
                <button onClick={nextPage} disabled={currentPage == totalPages} className={`px-3 py-1 rounded-md bg-black text-white disabled:cursor-not-allowed disabled:text-black disabled:bg-gray-200`}>
                    next
                </button>
            </div>    
        </>
    )
}

export default Pagination;